import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss']
})
export class ListFilterComponent {
  @Input() searchTerm: string = '';
  @Input() placeholder: string = 'Search...';
  @Input() itemCount: number = 0;
  @Input() itemLabel: string = 'item';
  @Input() itemLabelPlural: string = 'items';
  @Input() createButtonLabel: string = 'Create New';
  @Input() createButtonIcon: string = 'pi pi-plus';
  @Input() showCreateButton: boolean = true;

  @Output() searchTermChange = new EventEmitter<string>();
  @Output() createClicked = new EventEmitter<void>();

  onSearchChange(value: string): void {
    this.searchTermChange.emit(value);
  }

  onCreateClick(): void {
    this.createClicked.emit();
  }

  get countLabel(): string {
    return this.itemCount === 1 ? this.itemLabel : this.itemLabelPlural;
  }
}
